// ============================================================================
// LE SENS DE SYNCHRONISATION D'UN MAGASIN — partagé par l'assistant de mise en service et la fiche magasin.
// ============================================================================

/**
 * LES DEUX SENS DE SYNCHRONISATION, et ce qu'ils changent — c'est le RÉGLAGE qui va et vient, jamais une vente.
 * ⚠️ Le mono-directionnel est appliqué des deux côtés (§12.9.1) : la caisse affiche les réglages du magasin en lecture
 *    seule, et le serveur de synchronisation refuse leur remontée. Une caisse d'une version antérieure ne grise pas son
 *    écran : sa modification reste sur elle, le serveur la refuse — l'écran le dit plutôt que de promettre plus (§23.0).
 */
export const SYNC_MODES = [
  { k: 'bi', label: 'Bidirectionnel', desc: 'Une caisse peut modifier ses réglages sur place, selon les droits de l’opérateur, et ils remontent au back-office. C’est le réglage par défaut.' },
  { k: 'mono', label: 'Mono-directionnel', desc: 'Le siège décide de tous les réglages du magasin : les caisses les affichent en lecture seule, seules les préférences de l’appareil (affichage, terminal, imprimante) restent modifiables sur place. Une caisse d’une version antérieure ne grise pas ses réglages, mais le serveur refuse qu’ils remontent.' },
] as const;

/** Le libellé et la description d'un sens, tels que l'écran les dit. */
export const syncModeOf = (k: 'mono' | 'bi') => SYNC_MODES.find((m) => m.k === k) ?? SYNC_MODES[0];
